import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"warning\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFBB03\" cx=\"10\" cy=\"10\" r=\"10\" /><path fill=\"#FFF\" d=\"M8.571 13.333h2.857v2.857H8.571zM8.25 3.81h3.589l-.41 8.571H8.57z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id